import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfDigitalIntensityScoreGoalService } from '../../../core/application/services/goals/get-self-digital-intensity-score-goal.service';
import { SelfDigitalIntensityScoreGoalEntity } from '../../../core/domain/entities/goals/score-goals/self-digital-intensity-score-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfDigitalIntensityScoreGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfDigitalIntensityScoreGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfDigitalIntensityScoreGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
